import React, { useRef, useState, useEffect } from 'react'
import ReceiptView from './ReceiptView'
import { useReactToPrint } from 'react-to-print'

export default function Receipt({receipt, team, manager}) {
    const [items, setItems] = useState([])
    const componentRef = React.useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });


    useEffect(() => {
        let arr = []
        if (!receipt.version) {
            if (receipt.plan) {
                arr.push({
                    name: `${receipt.plan} Plan`, 
                    cost: 30, 
                    quantity: 1, 
                    tax: 0, 
                    total: 30
                })
            }

            if (receipt.profiles) {
                let additionalProfiles = receipt.plan ? receipt.profiles - 200 : receipt.profiles
                let amount = receipt.plan ? receipt.amount - 30 : receipt.amount
                amount = receipt.domain ? amount - 100 : amount
                arr.push({
                    name: `Addtional Profiles (100 per item)`, 
                    quantity: parseInt(additionalProfiles / 100), 
                    cost: 5, 
                    tax: 0, 
                    total: parseFloat(amount)
                })
            }

            if (receipt.domain) {
                arr.push({
                    name: `Custom Domain Add On (one-time charge)`, 
                    quantity: 1, 
                    cost: 100, 
                    tax: 0, 
                    total: 100
                })
            }
        } else {
            if (receipt.plan && receipt.plan_amount && receipt.plan_amount > 0) {
                arr.push({
                    name: `${receipt.plan} Plan`, 
                    cost: receipt.plan_amount, 
                    quantity: 1, 
                    tax: 0, 
                    total: receipt.plan_amount
                })
            }

            if (receipt.profiles && receipt.profile_amount && receipt.profile_amount > 0) {
                let additionalProfiles = receipt.plan ? receipt.profiles - 200 : receipt.profiles
                let amount = receipt.profile_amount
                let cost = amount / (additionalProfiles / 100)
                arr.push({
                    name: `Addtional Profiles (100 per item)`, 
                    quantity: parseInt(additionalProfiles / 100), 
                    cost: cost, 
                    tax: 0, 
                    total: parseFloat(amount)
                })
            }

            if (receipt.domain && receipt.domain_amount && receipt.domain_amount > 0) {
                arr.push({
                    name: `Custom Domain Add On (one-time charge)`, 
                    quantity: 1, 
                    cost: receipt.domain_amount, 
                    tax: 0, 
                    total: receipt.domain_amount
                })
            }
        }

        setItems(arr)
    }, [])

  return (
    <div>
        <div className="page-header d-flex align-items-baseline">
            <h4 className="">
                <a href="/team/plan">
                <i className="fa fa-chevron-left mr-2"></i> Back
                </a>
            </h4>
            <ul className="breadcrumbs">
                <li className="nav-item">
                Receipt
                </li>

                <li className="separator">
                <i className="fa fa-arrow-right"></i>
                </li>
                <li className="nav-item">
                {receipt.receipt_id}
                </li>
            </ul>

            <div className='page-actions'>
                <button className='btn btn-primary' onClick={handlePrint} >Print PDF</button>
            </div>
        </div>

        <ReceiptView 
            receipt={receipt} 
            team={team} 
            manager={manager} 
            items={items}
            ref={componentRef}
        />
    </div>
  )
}
